var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#789984"
    },
    d: "M436.918,74.977l-6.395,6.475l-3.277,3.277c-43.804-43.884-104.394-70.98-171.298-70.98 c-133.81,0-242.279,108.471-242.279,242.278c0,66.906,27.097,127.496,70.981,171.3l-9.672,9.672 c-17.905-17.905-33.093-38.289-45.003-60.829C10.791,340.359,0,299.432,0,256.026C0,114.624,114.545,0,255.948,0 c46.121,0,89.446,12.228,126.855,33.732C402.707,45.002,420.852,58.91,436.918,74.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M427.254,84.712c43.841,43.841,70.958,104.408,70.958,171.307 c0,133.799-108.466,242.265-242.265,242.265c-66.9,0-127.466-27.116-171.307-70.958l-9.698,9.699 C121.265,483.349,185.26,512,255.947,512c141.374,0,255.981-114.607,255.981-255.981c0-70.687-28.652-134.682-74.975-181.005 L427.254,84.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDEC"
    },
    d: "M255.947,498.284c133.799,0,242.265-108.466,242.265-242.265 c0-66.899-27.116-127.465-70.958-171.307L84.64,427.326C128.481,471.168,189.047,498.284,255.947,498.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M13.682,256.019c0,66.9,27.116,127.466,70.957,171.307L427.254,84.712 c-43.841-43.842-104.408-70.958-171.307-70.958C122.148,13.755,13.682,122.22,13.682,256.019z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#369E92"
    },
    points: "241.132,262.617 254.011,243.18 428.553,372.825  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4A6A54"
    },
    cx: 255.947,
    cy: 256.02,
    r: 23.774
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4A6A54"
    },
    points: "240.625,244.809 253.959,277.644 72.23,332.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4A6A54"
    },
    points: "271.606,267.771 241.132,246.339 344.299,132.024  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M201.033,58.19c-3.3,0-6.202-2.231-7.058-5.424c-0.505-1.888-0.245-3.859,0.732-5.551 c0.977-1.693,2.554-2.904,4.442-3.409c0.623-0.166,1.263-0.252,1.9-0.252c3.299,0,6.202,2.231,7.058,5.426 c0.505,1.888,0.247,3.858-0.73,5.551c-0.977,1.691-2.554,2.902-4.442,3.408C202.31,58.106,201.671,58.19,201.033,58.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M310.845,468.01c-3.3,0-6.203-2.232-7.06-5.426c-0.505-1.888-0.245-3.859,0.732-5.551 c0.977-1.693,2.554-2.904,4.442-3.409c0.623-0.166,1.263-0.252,1.9-0.252c3.3,0,6.202,2.232,7.06,5.426 c1.043,3.895-1.277,7.915-5.174,8.96C312.122,467.925,311.483,468.01,310.845,468.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M51.047,208.194c-0.638,0-1.277-0.084-1.9-0.252c-1.889-0.505-3.466-1.716-4.443-3.407 c-0.977-1.693-1.238-3.663-0.732-5.551c0.856-3.195,3.759-5.426,7.06-5.426c0.637,0,1.277,0.086,1.9,0.252 c1.888,0.505,3.465,1.716,4.441,3.409c0.977,1.691,1.238,3.663,0.732,5.551C57.247,205.963,54.345,208.194,51.047,208.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M460.864,318.006c-0.638,0-1.277-0.086-1.9-0.252c-3.897-1.045-6.217-5.065-5.174-8.96 c0.857-3.193,3.759-5.426,7.06-5.426c0.638,0,1.277,0.086,1.9,0.252c1.888,0.505,3.465,1.716,4.442,3.409 c0.977,1.691,1.238,3.663,0.732,5.551C467.066,315.774,464.164,318.006,460.864,318.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M51.031,318.006c-3.3,0-6.204-2.231-7.06-5.426c-0.505-1.888-0.245-3.859,0.732-5.551 c0.977-1.693,2.554-2.904,4.442-3.409c0.623-0.166,1.263-0.252,1.9-0.252c3.3,0,6.202,2.232,7.06,5.426 c1.043,3.895-1.277,7.915-5.174,8.96C52.307,317.92,51.668,318.006,51.031,318.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M460.847,208.194c-3.299,0-6.201-2.231-7.058-5.424c-0.505-1.888-0.245-3.859,0.732-5.551 c0.977-1.693,2.554-2.904,4.442-3.409c0.623-0.166,1.263-0.252,1.9-0.252c3.3,0,6.202,2.232,7.06,5.426 c0.505,1.888,0.245,3.858-0.732,5.551c-0.977,1.691-2.554,2.902-4.442,3.407C462.124,208.11,461.485,208.194,460.847,208.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M201.049,468.01c-0.638,0-1.277-0.086-1.9-0.252c-3.897-1.045-6.217-5.065-5.174-8.96 c0.855-3.195,3.759-5.426,7.06-5.426c0.638,0,1.277,0.086,1.9,0.252c1.888,0.505,3.465,1.716,4.442,3.408 c0.977,1.693,1.236,3.665,0.73,5.552C207.251,465.78,204.348,468.01,201.049,468.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M310.861,58.19c-0.638,0-1.277-0.084-1.9-0.252c-1.889-0.505-3.466-1.716-4.443-3.408 c-0.977-1.693-1.238-3.663-0.732-5.551c0.857-3.193,3.759-5.426,7.06-5.426c0.638,0,1.277,0.086,1.9,0.252 c1.888,0.506,3.465,1.716,4.442,3.409c0.977,1.691,1.238,3.663,0.732,5.551C317.062,55.959,314.16,58.19,310.861,58.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M149.888,79.381c-2.611,0-5.042-1.402-6.344-3.659c-0.979-1.691-1.238-3.663-0.732-5.551 c0.505-1.886,1.716-3.465,3.408-4.44c1.113-0.643,2.375-0.982,3.649-0.982c2.611,0,5.042,1.4,6.344,3.658 c0.979,1.693,1.238,3.665,0.732,5.552c-0.505,1.886-1.716,3.463-3.409,4.44C152.422,79.042,151.161,79.381,149.888,79.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M362.026,446.815c-2.611,0-5.042-1.402-6.344-3.659c-2.018-3.493-0.818-7.976,2.675-9.994 c1.113-0.641,2.374-0.98,3.647-0.98c2.611,0,5.043,1.402,6.345,3.659c0.979,1.693,1.238,3.665,0.732,5.552 c-0.505,1.886-1.716,3.463-3.409,4.44C364.56,446.476,363.299,446.815,362.026,446.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M72.22,157.029c-1.273,0-2.536-0.339-3.649-0.982c-1.691-0.975-2.902-2.554-3.408-4.44 c-0.505-1.888-0.246-3.859,0.732-5.552c1.302-2.257,3.734-3.659,6.345-3.659c1.273,0,2.533,0.339,3.645,0.982 c1.693,0.977,2.904,2.554,3.409,4.442c0.505,1.888,0.246,3.859-0.73,5.551C77.262,155.627,74.831,157.029,72.22,157.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M439.654,369.167c-1.273,0-2.536-0.339-3.649-0.982c-3.493-2.016-4.693-6.499-2.677-9.992 c1.302-2.257,3.734-3.659,6.347-3.659c1.273,0,2.532,0.339,3.645,0.982c1.693,0.977,2.904,2.554,3.409,4.442 c0.505,1.888,0.246,3.859-0.73,5.551C444.696,367.765,442.265,369.167,439.654,369.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M72.24,369.167c-2.611,0-5.042-1.402-6.344-3.659c-2.018-3.493-0.818-7.976,2.675-9.994 c1.113-0.641,2.373-0.98,3.647-0.98c2.611,0,5.043,1.402,6.345,3.659c0.979,1.693,1.238,3.665,0.732,5.552 c-0.505,1.886-1.716,3.463-3.409,4.44C74.774,368.828,73.513,369.167,72.24,369.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M439.674,157.029c-2.611,0-5.042-1.402-6.345-3.659c-2.016-3.493-0.816-7.976,2.677-9.994 c1.113-0.641,2.373-0.98,3.647-0.98c2.611,0,5.043,1.402,6.345,3.659c0.979,1.693,1.238,3.665,0.732,5.552 c-0.505,1.886-1.716,3.463-3.409,4.44C442.208,156.69,440.947,157.029,439.674,157.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M149.868,446.815c-1.273,0-2.536-0.339-3.649-0.982c-1.691-0.975-2.902-2.554-3.408-4.44 c-0.505-1.888-0.247-3.859,0.732-5.552c1.302-2.257,3.734-3.659,6.345-3.659c1.273,0,2.532,0.339,3.645,0.982 c1.693,0.977,2.904,2.554,3.409,4.441s0.247,3.859-0.73,5.551C154.91,445.413,152.479,446.815,149.868,446.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A6A54"
    },
    d: "M362.006,79.381c-1.273,0-2.536-0.339-3.649-0.982c-1.691-0.975-2.902-2.554-3.407-4.44 c-0.505-1.888-0.246-3.859,0.732-5.552c1.302-2.257,3.733-3.658,6.344-3.658c1.273,0,2.534,0.339,3.647,0.98 c1.693,0.979,2.904,2.556,3.409,4.442c0.506,1.888,0.247,3.859-0.73,5.551C367.048,77.979,364.617,79.381,362.006,79.381z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.631,
    y: 36.328,
    style: {
      fill: "#4A6A54"
    },
    width: 14.63,
    height: 52.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.631,
    y: 423.114,
    style: {
      fill: "#4A6A54"
    },
    width: 14.63,
    height: 52.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.881,
    y: 92.971,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 287.6506 118.9157)",
    style: {
      fill: "#4A6A54"
    },
    width: 14.631,
    height: 52.122
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.381,
    y: 366.472,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 947.9358 392.4151)",
    style: {
      fill: "#4A6A54"
    },
    width: 14.631,
    height: 52.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.137,
    y: 385.216,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 481.039 585.8167)",
    style: {
      fill: "#4A6A54"
    },
    width: 52.121,
    height: 14.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.636,
    y: 111.717,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 754.538 -74.4862)",
    style: {
      fill: "#4A6A54"
    },
    width: 52.121,
    height: 14.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.493,
    y: 248.466,
    style: {
      fill: "#4A6A54"
    },
    width: 52.12,
    height: 14.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.279,
    y: 248.466,
    style: {
      fill: "#4A6A54"
    },
    width: 52.12,
    height: 14.63
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.94cb8882bf5262813bfec43e5806ce0a.svg";
export { ForwardRef as ReactComponent };